<template>
  <aside class="filters">
    <filters-container @close="$emit('close')"/>
  </aside>
</template>

<script>
import ButtonComponent from '@/components/Button'
import FiltersContainer from '@/containers/Settings/FiltersContainer'

export default {
  components: {
    ButtonComponent,
    FiltersContainer
  }
}
</script>

<style lang="scss" scoped>
  .filters {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $base-text-color;
    color: $base-opposite-color;
    z-index: z(logo) - 1;
  }
</style>



// WEBPACK FOOTER //
// src/containers/Settings/Filters.vue